import _classCallCheck from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/cicd/cicd-pipeline/staticweb_build/xp-charge-web-fe/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { ClassList } from '@xpeng/rc-utils'; // import * as styles from './styles';

import "./index.css";
var styles = {
  "wrapper": "_wrapper_1pk5u_1",
  "container": "_container_1pk5u_13",
  "invisible": "_invisible_1pk5u_23"
};
var Toast = /*#__PURE__*/function (_Component) {
  _inherits(Toast, _Component);
  var _super = _createSuper(Toast);
  function Toast() {
    var _this;
    _classCallCheck(this, Toast);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "timer", void 0);
    _defineProperty(_assertThisInitialized(_this), "state", {
      visible: true
    });
    return _this;
  }
  _createClass(Toast, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
    }
  }, {
    key: "hide",
    value: function hide(callback) {
      var _this2 = this;
      var visible = this.state.visible;
      var duration = this.props.duration;
      if (visible) {
        this.timer = window.setTimeout(function () {
          _this2.setState({
            visible: false
          }, callback);
        }, duration);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        style = _this$props.style,
        containerStyle = _this$props.containerStyle,
        container = _this$props.container,
        children = _this$props.children;
      var visible = this.state.visible;
      var containerClass = new ClassList(styles.container);
      var wrapperClass = new ClassList(styles.wrapper);
      if (!visible) {
        containerClass.add(styles.invisible);
      }
      return ReactDOM.createPortal(React.createElement("div", {
        className: containerClass.toString(),
        style: containerStyle
      }, React.createElement("div", {
        className: wrapperClass.toString(),
        style: style
      }, children)), typeof container === 'string' ? document.getElementById(container) : container);
    }
  }]);
  return Toast;
}(Component);
_defineProperty(Toast, "defaultProps", {
  duration: 3000,
  container: 'toast-root'
});
_defineProperty(Toast, "show", function show(content, options) {
  var div = document.createElement('div');
  document.body.appendChild(div);
  var toast = ReactDOM.render(React.createElement(Toast, _extends({
    container: div
  }, options), content), div);
  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }
  toast.hide(function () {
    destroy();
  });
});
export default Toast;